import type { LifecycleStateFilter, TrackingLevelFilter } from '../types/lifecycle';

interface TrackedFilterBarProps {
  trackingLevel: TrackingLevelFilter;
  lifecycleState: LifecycleStateFilter;
  hideArchival: boolean;
  search: string;
  total: number;
  visible: number;
  hiddenArchival: number;
  hiddenStaleUnanalyzed: number;
  onTrackingLevelChange: (v: TrackingLevelFilter) => void;
  onLifecycleStateChange: (v: LifecycleStateFilter) => void;
  onHideArchivalChange: (v: boolean) => void;
  onSearchChange: (v: string) => void;
}

const LEVEL_OPTIONS: { value: TrackingLevelFilter; label: string }[] = [
  { value: 'all', label: 'Vše' },
  { value: 'critical', label: 'Kritické' },
  { value: 'high', label: 'Vysoké' },
  { value: 'medium', label: 'Střední' },
  { value: 'low', label: 'Nízké' },
  { value: 'archival', label: 'Archivální' },
];

const STATE_OPTIONS: { value: LifecycleStateFilter; label: string }[] = [
  { value: 'all', label: 'Všechny stavy' },
  { value: 'active', label: 'Aktivně sledované' },
  { value: 'in_analysis', label: 'V analýze' },
  { value: 'analysis_synced', label: 'Analyzované' },
  { value: 'closed', label: 'Schválené/Zamítnuté' },
];

export function TrackedFilterBar(props: TrackedFilterBarProps) {
  return (
    <div className="filter-bar tracked-filter-bar">
      <div className="filter-bar__risk">
        {LEVEL_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            className={`risk-btn ${props.trackingLevel === opt.value ? 'risk-btn--active' : ''}`}
            onClick={() => props.onTrackingLevelChange(opt.value)}
            aria-pressed={props.trackingLevel === opt.value}
          >
            {opt.label}
          </button>
        ))}
      </div>

      <div className="tracked-filter-bar__row">
        <select
          className="tracked-filter-bar__select"
          value={props.lifecycleState}
          onChange={(e) => props.onLifecycleStateChange(e.target.value as LifecycleStateFilter)}
          aria-label="Lifecycle stav"
        >
          {STATE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>

        <label className="tracked-filter-bar__checkbox">
          <input
            type="checkbox"
            checked={props.hideArchival}
            onChange={(e) => props.onHideArchivalChange(e.target.checked)}
          />
          <span>Skrýt archivální</span>
        </label>
      </div>

      <div className="filter-bar__search">
        <input
          type="search"
          placeholder="Hledat název nebo číslo tisku…"
          aria-label="Hledat v sledovaných návrzích podle názvu nebo čísla tisku"
          value={props.search}
          onChange={(e) => props.onSearchChange(e.target.value)}
        />
      </div>

      <div className="tracked-filter-bar__counts">
        {props.visible} návrhů z {props.total} celkem
        {(props.hiddenArchival > 0 || props.hiddenStaleUnanalyzed > 0) && (
          <>
            {' · skryto '}
            {props.hiddenArchival > 0 && `${props.hiddenArchival} archivních`}
            {props.hiddenArchival > 0 && props.hiddenStaleUnanalyzed > 0 && ' + '}
            {props.hiddenStaleUnanalyzed > 0 && `${props.hiddenStaleUnanalyzed} zastaralých bez analýzy`}
          </>
        )}
      </div>
    </div>
  );
}
